import api from '.';
import logger from '../utils/logger';
import {
  CartResponse,
  IsTaxExemptRequestParams,
  IsTaxExemptResponse,
  UpdateCartRequest,
  UpdateCartResponse,
} from '../types/cart';

const urlPrefix = '/rental-cart-service';

export const getCart = async (userUuid: string): Promise<CartResponse | null> => {
  try {
    const { data } = await api.get(`${urlPrefix}/carts/${userUuid}`);
    return data;
  } catch (error) {
    logger('error', 'error fetching cart details', error);
    throw error;
  }
};

export const newCart = async (
  requestBody: UpdateCartRequest,
): Promise<UpdateCartResponse | null> => {
  try {
    if (requestBody.cart_details.length === 0) {
      throw new Error('at newCart: cart_details cannot be empty for POST api call');
    }
    const { data } = await api.post(`${urlPrefix}/carts`, requestBody);
    return data;
  } catch (error) {
    logger('error', 'error creating new backend cart ', error);
    throw error;
  }
};

export const overwriteCart = async (
  requestBody: UpdateCartRequest,
  userUuid: string,
): Promise<UpdateCartResponse | null> => {
  await api
    .put(`${urlPrefix}/carts/${userUuid}`, requestBody)
    .then((response) => {
      logger('info', 'Response from server: ', response.data);
      return response;
    })
    .catch((error) => {
      logger('error', 'error updating backend cart ', error);
      throw error;
    });
  return null;
};

export const getIsTaxExempt = async (
  companyId: number,
  branchId: number,
  params: IsTaxExemptRequestParams,
): Promise<IsTaxExemptResponse> => {
  try {
    const locationParam = params.jobsiteId
      ? `jobsite_id=${params.jobsiteId}`
      : `state=${params.stateAbbreviation}`;

    const { data } = await api.get(
      `/billing/is-company-tax-exempt/${companyId}?branch_id=${branchId}&${locationParam}`,
    );
    return data;
  } catch (error) {
    logger('error', 'at getIsTaxExempt while fetching tax exempt data', error);
    throw new Error('error at getIsTaxExempt while fetching tax exempt data');
  }
};
